import { useEffect, useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useNavigate } from "react-router-dom";

import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import LeadList from "./LeadList";
import MailingListData from "./MailingListData";
import { PAGES_DOMAIN_URL } from "constants";

export default ({ listId }) => {
  const navigate = useNavigate();

  const [loadingNotificationsToggle, setLoadingNotificationsToggle] =
    useState(false);

  // Fetch data
  const GET_MAILING_LIST_DATA = gql`
    query GetMailingListData($listId: ID!) {
      mailingListData(listId: $listId) {
        list {
          id
          name
          pages {
            id
            name
            code
          }
          lead_notification
        }
        last24HoursLeads
        last24HoursVerifiedLeads
        prev24HoursLeads
        prev24HoursVerifiedLeads
        last7DaysLeads
        last7DaysVerifiedLeads
        prev7DaysLeads
        prev7DaysVerifiedLeads
        allLeads
        allVerifiedLeads
      }
    }
  `;

  const { data, error } = useQuery(GET_MAILING_LIST_DATA, {
    variables: {
      listId,
    },
    skip: !listId,
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching mailing list data", error);
    captureException(error);
  }

  const onPageClick = (code) => {
    window.open(`${PAGES_DOMAIN_URL}/?code=${code}`, "_blank").focus();
  };

  useEffect(() => {
    if (data) {
      if (!data.mailingListData.list) navigate("/mailing-lists");
    }
  }, [data]);

  // handle Notifications toggle
  const TOGGLE_PAGE_NOTIFICATIONS = gql`
    mutation TogglePageNotifications($listId: ID!) {
      togglePageListNotifications(listId: $listId) {
        id
        lead_notification
      }
    }
  `;

  const [togglePageListNotifications] = useMutation(TOGGLE_PAGE_NOTIFICATIONS);

  const onNotificationsToggleClick = async () => {
    try {
      if (!data) return;

      setLoadingNotificationsToggle(true);

      await togglePageListNotifications({
        variables: {
          listId: data.mailingListData.list.id,
        },
      });

      setLoadingNotificationsToggle(false);
    } catch (error) {
      console.log("error onNotificationsToggleClick", error);
      captureException(error);
      setLoadingNotificationsToggle(false);
      return;
    }
  };

  //console.log("data", data);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="280px" />
        </LoadingBox>
      )}
      {data?.mailingListData.list && (
        <MailingListData
          data={data}
          onPageClick={onPageClick}
          onNotificationsToggleClick={onNotificationsToggleClick}
        />
      )}
    </>
  );
};
